// import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import log from '@/configured/logger';
import localforage from 'localforage';
import mixins from '@/mixins';

const serviceWorkerUsed = navigator && navigator.serviceWorker;
const applicationCacheUsed = !serviceWorkerUsed && window.applicationCache;
let hasDownloadInitialized = false;
debuggingForOfflinePluginAppCacheEvents();

export default {
  init,
  remove,
};

//////////

function init({
  onInstalledCallback,
  onUpdatingCallback,
  onUpdateReadyCallback,
  onUpdatedCallback,
  onUpdateFailedCallback,
}) {
  return;
  // Disabled for now
  // jkca: 2023-04-10
  // if(!mixins.all.supportedFeaturesOfflineMode) {
  //   log.warn('Offline not supported in IE or Edge');
  //   return;
  // }

  // if(hasDownloadInitialized) {
  //   log.info('Offline download updating');
  //   return OfflinePluginRuntime.update();
  // }

  // log.info('Offline download initializing');
  // hasDownloadInitialized = true;
  // const onInstalled    = passThroughEventCallbackAndDoNothing('onInstalled', onInstalledCallback);
  // const onUpdating     = passThroughEventCallbackAndDoNothing('onUpdating', onUpdatingCallback);
  // const onUpdateReady  = passThroughEventCallbackAndDoNothing('onUpdateReady', onUpdateReadyCallback);
  // const onUpdated      = passThroughEventCallbackAndDoNothing('onUpdated', onUpdatedCallback);
  // const onUpdateFailed = passThroughEventCallbackAndDoNothing('onUpdateFailed', onUpdateFailedCallback);

  // serviceWorkerInitialStateCheck(onInstalled, onUpdating);
  // applicationCacheInitialStateCheck(onInstalled, onUpdating, onUpdateReady, onUpdateFailed);

  // OfflinePluginRuntime.install({
  //   onInstalled,
  //   onUpdating,
  //   onUpdateReady,
  //   onUpdated,
  //   onUpdateFailed
  // });

  // requestPersistentStorage();
}

function serviceWorkerInitialStateCheck(completeCallback, updatingCallback) {
  if (!serviceWorkerUsed || !navigator.serviceWorker.getRegistrations) {
    return;
  }

  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    console.info('Service worker registrations', registrations);

    if (
      registrations[0] &&
      (registrations[0].installing || registrations[0].waiting)
    ) {
      updatingCallback();
    } else if (registrations[0] && registrations[0].active) {
      completeCallback();
    }
  });
}

function applicationCacheInitialStateCheck(
  completeCallback,
  updatingCallback,
  updateReadyCallback,
  failedCallback
) {
  if (!applicationCacheUsed) {
    return;
  }

  log.info('applicationCache.status', applicationCache.status);

  if (window.applicationCache.status === window.applicationCache.UPDATEREADY) {
    updateReadyCallback();
  } else if (
    window.applicationCache.status === window.applicationCache.IDLE ||
    window.applicationCache.status === window.applicationCache.UNCACHED
  ) {
    completeCallback();
  } else if (
    window.applicationCache.status === window.applicationCache.OBSOLETE
  ) {
    failedCallback();
  } else {
    updatingCallback();
  }

  // https://developer.mozilla.org/en-US/docs/Web/HTML/Using_the_application_cache
  // This is needed because Offline Plugin events are not reliable.
  // iOS 10.3 does not send the completed event after download and onUpdate is not implemented.
  [
    'updateready',
    'noupdate',
    'progress',
    'downloading',
    'cached',
    'obsolete',
    'error',
  ].forEach((eventName) => {
    window.applicationCache.addEventListener(eventName, () => {
      log.info('AppCache event', eventName);

      if (eventName === 'updateready') {
        updateReadyCallback();
      } else if (eventName === 'noupdate' || eventName === 'cached') {
        completeCallback();
      } else if (eventName === 'obsolete' || eventName === 'error') {
        failedCallback();
      } else {
        updatingCallback();
      }
    });
  });
}

function passThroughEventCallbackAndDoNothing(name, callback) {
  return (event) => {
    log.info('Offline download event', name, event);
    if (typeof callback === 'function') {
      callback(event);
    }
  };
}

function debuggingForOfflinePluginAppCacheEvents() {
  if (window.addEventListener) {
    window.addEventListener(
      'message',
      function (event) {
        if (
          event &&
          event.data &&
          event.data.source &&
          event.data.source === 'vue-devtools-backend'
        ) {
          return;
        }
        log.info('iframe event', event);
      },
      false
    );
  }
}

function remove(
  clearCacheStorage = true,
  clearServiceWorkers = true,
  clearIndexedDB = true
) {
  if (!mixins.all.supportedFeaturesOfflineMode) {
    log.warn('Offline not supported in IE or Edge');
    return Promise.resolve();
  }

  log.info('Remove cache', {
    serviceWorkerUsed,
    applicationCacheUsed,
    hasDownloadInitialized,
  });

  if (applicationCacheUsed && hasDownloadInitialized) {
    // To delete app cache, the server must respond with an empty manifest.
    log.info('Remove cache called with appCache, calling update');
    OfflinePluginRuntime.update();
    if (clearIndexedDB) {
      return removeIndexedDB();
    } else {
      return Promise.resolve();
    }
  } else if (applicationCacheUsed) {
    log.warn(
      'Remove cache called with appCache but download is not initialized yet'
    );
    if (clearIndexedDB) {
      return removeIndexedDB();
    } else {
      return Promise.resolve();
    }
  }

  log.info('Removing service worker cache');

  return new Promise((overallResolve, overallReject) => {
    Promise.all([
      (() => {
        if (window.caches && clearCacheStorage) {
          let cachePromises = [];
          caches.keys().then((cacheNames) => {
            log.info(`Number of caches: ${cacheNames.length}`);
            cacheNames.forEach((cacheName) => {
              let itemAction = caches.delete(cacheName);
              cachePromises.push(itemAction);

              itemAction.then(
                () => {
                  log.info(`Cache deleted: ${cacheName}`);
                },
                () => {
                  log.info(`Delete Failed: ${cacheName}`);
                }
              );
            });
          });
          return cachePromises;
        }
      })(),
      (() => {
        if (
          clearServiceWorkers &&
          navigator &&
          navigator.serviceWorker &&
          navigator.serviceWorker.getRegistrations
        ) {
          let registrationResolve;
          let registrationReject;
          let serviceWorkerPromises = [];
          const registrationPromise = new Promise((resolve, reject) => {
            registrationResolve = resolve;
            registrationReject = reject;
          });

          navigator.serviceWorker.getRegistrations().then(
            function (registrations) {
              log.info('service worker registrations', registrations);
              for (let registration of registrations) {
                let unregisterPromise = registration.unregister();
                log.info('unregisterPromise', unregisterPromise);
                serviceWorkerPromises.push(unregisterPromise);

                unregisterPromise.then(
                  (_) => {
                    log.info('Service worker unregistered');
                  },
                  (_) => {
                    log.info('Could not clear unregister service worker');
                  }
                );
              }
              Promise.all(serviceWorkerPromises).then(
                registrationResolve,
                registrationReject
              );
            },
            () => {
              log.info('Unable to get service worker registrations');
              registrationReject();
            }
          );

          return registrationPromise;
        }
      })(),
    ]).then(() => {
      // Stage 2, after cache and service workers are cleared
      Promise.all([
        (() => {
          // Clear IndexedDB last because other changes could trigger a mutation and re-save IndexedDB
          if (clearIndexedDB) {
            return removeIndexedDB();
          }
        })(),
      ]).then(overallResolve, overallReject);
    }, overallReject);
  });
}

function removeIndexedDB() {
  return localforage.clear().then(
    () => log.info('IndexedDB is now empty'),
    () => log.info('Could not clear IndexedDB')
  );
}

// function requestPersistentStorage () {
//   if (navigator.storage && navigator.storage.persist) {
//     navigator.storage.persisted().then(persistent => {
//       if (persistent)
//         log.info("Persist storage approved. Storage will not be cleared except by explicit user action.");
//       else
//         log.warn("Persist storage denied. Storage may be cleared by the UA under storage pressure.");
//     });
//   }else {
//     log.warn('Persist storage api is unavailable in this browser.');
//   }
// }
